export function assertDefined(value) {
    if (value === null || value === undefined) {
        throw new Error('value is not defined');
    }
}
export function assert(value, message = 'Assertion failed') {
    if (!value) {
        throw new Error(message);
    }
}
export function unreachable(param) {
    return new Error(`Unreachable case with value ${JSON.stringify(param)}`);
}
// General type utility function to narrow down discriminated union types
export const isOfType = ((tagOrTags, maybeItem) => {
    const tags = Array.isArray(tagOrTags) ? tagOrTags : [tagOrTags];
    if (maybeItem) {
        return tags.includes(maybeItem.type);
    }
    else {
        return (item) => tags.includes(item.type);
    }
});
export const isDefined = (item) => item !== null && item !== undefined;
export const keys = Object.keys;
export function assertFields(obj, fields, objectName) {
    const notFoundFields = fields.filter((key) => obj[key] === undefined);
    if (notFoundFields.length) {
        throw new Error(`${objectName}: Expected fields ${fields.join(', ')}, but these fields where missing: ${notFoundFields.join(', ')}`);
    }
}
//# sourceMappingURL=ts-utils.js.map